import React from 'react';

function FeatureList({ features = [] }) {
  return (
    <div className="space-y-4">
      {features.map((feature, index) => (
        <div key={index} className="flex items-start">
          {feature.icon && (
            <div className="flex-shrink-0 mr-3 mt-1">{feature.icon}</div>
          )}
          <div>
            {feature.title && (
              <h3 className="font-semibold mb-1 text-gray-900">
                {feature.title}
              </h3>
            )}
            {feature.description && (
              <p className="text-gray-600 text-sm">{feature.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeatureList;

